import { LoadablePaint } from '@confluence/loadable';

export const ViewPageContentLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ViewPageContent" */ './ViewPageContent'))
			.ViewPageContent,
});
